// Polyfill smooth scroll for native window.scroll methods
// See http://iamdustan.com/smoothscroll/
import smoothscroll from 'smoothscroll-polyfill';
import VModal from 'vue-js-modal';
import FormLoader from 'vue-form-loader';
import PortalVue from 'portal-vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueCookies from 'vue-cookies';
import VeeValidate, { Validator } from 'vee-validate';
import sv from 'vee-validate/dist/locale/sv';
import en from 'vee-validate/dist/locale/en';
import Vue from 'vue';
window.Vue = Vue;

smoothscroll.polyfill();


require('./bootstrap');
require('./utils');
require('./directives');

// Use google maps but don't install all components globally
if (window.App && window.App['googleMapsKey']) {
    Vue.use(VueGoogleMaps, {
        load: {
            key: window.App.googleMapsKey,
        },
        installComponents: false,
    });
    Vue.component('gmap-map', VueGoogleMaps.Map);
}

Vue.use(FormLoader);
Vue.use(VModal);
Vue.use(PortalVue);
Vue.use(VueCookies);

let locale = 'en';
if (window.App.locale === 'sv') {
    locale = 'sv';
}

Vue.use(VeeValidate, {
    locale: locale,
    classes: true,
    mode: 'lazy',
    events: 'blur',
    classNames: {
        valid: 'is-valid',
        invalid: 'error',
    },
});

if (locale === 'sv') {
    Validator.localize('sv', {
        ... sv,
        custom: {
            personal_identity_number: {
                required: 'Du måste fylla i ditt personnummer',
                regex: 'Dubbelkolla ditt personnummer är du snäll',
            },
            email: {
                required: 'Du måste fylla i en e-post',
                email: 'Dubbelkolla e-postadressen är du snäll',
            },
            code: {
                length: 'Hoppsan, registreringskoden har tyvärr inte rätt format',
            },
            send_to: {
                required: 'Du måste fylla i en e-post',
                email: 'Dubbelkolla E-postadressen är du snäll',
            },
            organization_number: {
                required: 'Du måste fylla i organisationsnummer',
                length: 'Ange på formatet: XXXXXX-XXXX',
            },
            mac: {
                regex: 'Ange på formatet: XX:XX:XX:XX:XX:XX',
            },
        },
        messages: {
            required: () => 'Hoppsan, du missade nog att fylla i något här',
            max: () => 'Prova med lite färre tecken här',
            min: () => 'Prova med lite fler tecken här',
            regex: () => 'Matcha formatet',
        },
    });
} else {
    Validator.localize('en', {
        ...en,
        custom: {
            email: {
                required: 'You seem to have forgotten the e-mail address',
                email: 'The e-mail address is incorrect',
            },
            code: {
                length: 'Whoops, the length of the code is incorrect',
            },
            send_to: {
                required: 'Don\'t forget the e-mail address',
                email: 'The e-mail address is incorrect',
            },
        },
        messages: {
            required: () => 'You seem to have missed a field here',
            max: () => 'You used too many characters here',
        },
    });
}

require('./fontawesome.js');
window.GtmTracker = require('./services/GtmTracker.js').default;

Vue.mixin({
    computed: {
        $isAnonymous() {
            return window.App.isAnonymous;
        },
        $customerIsLoggedIn() {
            return window.App.customerIsLoggedIn;
        },
        $customer() {
            return window.App.customer;
        },
        $EventBus() {
            return window.EventBus;
        },
        $GtmTracker() {
            return window.GtmTracker;
        },
    },
    methods: {
        route: typeof(Ziggy) !== 'undefined' ? window.route : null,
        lang: window.lang,
        scrollIt: window.utils.scrollIt,
        scrollItAndFocus: window.utils.scrollItAndFocus,
        translation: window.translation,
        format_sek: window.format_sek,
        format_sek_per_month: window.format_sek_per_month,
        scrollToSecondSection() {
            this.scrollIt(document.getElementsByTagName('section')[1]);
        },
    },
});

// Components provided by Atlantis...
Vue.component('on-click-outside', require('./components/Atlantis/OnClickOutside').default);
Vue.component('toggler', require('./components/Atlantis/Toggler').default);
Vue.component('popout', require('./components/Atlantis/Popout').default);
Vue.component('alert', require('./components/Atlantis/Alerts/Alert').default);
Vue.component('flashy-alert', require('./components/Atlantis/Alerts/FlashyAlert').default);
Vue.component('standard-modal', require('./components/Atlantis/Modals/StandardModal').default);
Vue.component('checkbox-input', require('./components/Atlantis/Forms/CheckboxInput').default);
Vue.component('text-input', require('./components/Front/Forms/TextInput').default);
Vue.component('select-input', require('./components/Atlantis/Forms/SelectInput').default);
Vue.component('textarea-input', require('./components/Atlantis/Forms/TextareaInput').default);
Vue.component('radio-input', require('./components/Atlantis/Forms/RadioInput').default);
Vue.component('password-input', require('./components/Atlantis/Forms/PasswordInput').default);

// Application specific components
Vue.component('create-new-password', require('./components/Front/Auth/CreateNewPassword').default);
Vue.component('info-box', require('./components/Front/InfoBox').default);
Vue.component('danger-button', require('./components/Front/DangerButton').default);
Vue.component('error-modal', require('./components/Front/Modals/ErrorModal').default);
Vue.component('form-modal', require('./components/Front/Modals/FormModal').default);
Vue.component('login-modal', require('./components/Front/LoginModal').default);
Vue.component('confirm-modal', require('./components/Shared/ConfirmModal').default);
Vue.component('edit-password', require('./components/Front/Forms/EditPassword').default);
Vue.component('mega-dropdown', require('./components/Front/MegaDropdown').default);
Vue.component('footer-menu', require('./components/Front/FooterMenu').default);
Vue.component('address-search', require('./components/Front/Order/AddressSearch').default);
Vue.component('global-search-autocomplete', require('./components/Front/Search/GlobalSearchAutocomplete').default);
Vue.component('guides-search-autocomplete', require('./components/Front/Search/GuidesSearchAutocomplete').default);
Vue.component('accordion', require('./components/Front/Accordion').default);
Vue.component('product-toggle', require('./components/Front/ProductToggle').default);
Vue.component('option-box-checkbox', require('./components/Front/OptionBoxCheckbox').default);
Vue.component('option-box-radio-container', require('./components/Front/OptionBoxRadioContainer').default);
Vue.component('option-box-radio', require('./components/Front/OptionBoxRadio').default);
Vue.component('mobile-menu-item-dropdown', require('./components/Front/MobileMenuItemDropdown').default);
Vue.component('broadband-speed-guide', require('./components/Front/Products/BroadbandSpeedGuide').default);
Vue.component('tv-base-packages-list', require('./components/Front/Tv/TvBasePackagesList').default);
Vue.component('tv-channel-packages-list', require('./components/Front/Tv/TvChannelPackagesList').default);
Vue.component('tv-extra-channels-list', require('./components/Front/Tv/TvExtraChannelsList').default);
Vue.component('base-map', require('./components/Front/Maps/BaseMap').default);
Vue.component('user-position-marker', require('./components/Front/Maps/UserPositionMarker').default);
Vue.component('schedule-customer-call', require('./components/Front/CustomerService/ScheduleCustomerCall').default);
Vue.component('service-status-subscription', require('./components/Front/CustomerService/ServiceStatusSubscription').default);
Vue.component('service-status-map', require('./components/Front/CustomerService/ServiceStatusMap').default);
Vue.component('service-status-marker', require('./components/Front/CustomerService/ServiceStatusMarker').default);
Vue.component('date-picker', require('./components/Shared/DatePicker').default);
Vue.component('update-messages-read-status', require('./components/Front/MyPages/UpdateMessagesReadStatus').default);
Vue.component('edit-profile-info', require('./components/Front/MyPages/EditProfileInfo').default);
Vue.component('edit-profile-password', require('./components/Front/MyPages/EditProfilePassword').default);
Vue.component('freshdesk-contact-form', require('./components/Front/MyPages/FreshdeskContactForm').default);
Vue.component('bank-id-auth', require('./components/Front/BankIdAuth').default);
Vue.component('file-input', require('./components/Front/FileInput').default);
Vue.component('router-guide', require('./components/Front/RouterGuide/RouterGuide').default);
Vue.component('email-accounts-and-aliases', require('./components/Front/MyPages/EmailAccount/EmailAccountsAndAliases').default);
Vue.component('router-management', require('./components/Front/MyPages/RouterManagement/RouterManagement').default);
Vue.component('tabs', require('./components/Front/Tabs/Tabs').default);
Vue.component('tab', require('./components/Front/Tabs/Tab').default);
Vue.component('service-accordion', require('./components/Front/MyPages/ServiceAccordion.vue').default);
Vue.component('telephony-configurator', require('./components/Front/Configurators/TelephonyConfigurator').default);
Vue.component('broadband-configurator', require('./components/Front/Configurators/Broadband/BroadbandConfigurator').default);
Vue.component('tv-configurator', require('./components/Front/Configurators/Tv/TvConfigurator').default);
Vue.component('tv-twin-configurator', require('./components/Front/Configurators/Tv/TvTwinConfigurator').default);
Vue.component('cart', require('./components/Front/Cart/Cart.vue').default);
Vue.component('cart-dropdown', require('./components/Front/Cart/CartDropdown.vue').default);
Vue.component('three-columns', require('./components/Front/Cms/Block/ThreeColumns.vue').default);
Vue.component('two-columns', require('./components/Front/Cms/Block/TwoColumns.vue').default);
Vue.component('add-to-cart-button', require('./components/Front/AddToCartButton.vue').default);
Vue.component('show-hide-button', require('./components/Shared/ShowHideButton.vue').default);
Vue.component('order-date-picker', require('./components/Front/Order/OrderDatePicker.vue').default);
Vue.component('ajax-form', require('./components/Front/AjaxForm.vue').default);
Vue.component('with-dimensions', require('./components/Front/WithDimensions.vue').default);
Vue.component('with-entered-viewport', require('./components/Front/WithEnteredViewport.vue').default);
Vue.component('choose-flex-channels-change-base-package', require('./components/Front/MyPages/ChooseFlexChannelsChangeBasePackage').default);
Vue.component('set-flex-channels', require('./components/Front/MyPages/SetFlexChannels').default);
Vue.component('cookie-modal', require('./components/Front/CookieModal/CookieModal').default);
Vue.component('feedback-bar', require('./components/Front/FeedbackBar').default);
Vue.component('read-more', require('./components/Front/ReadMore').default);
Vue.component('interest-form', require('./components/Front/InterestForm').default);
Vue.component('setting-with-checkbox', require('./components/Front/Configurators/Settings/SettingWithCheckbox').default);
Vue.component('add-streams', require('./components/Front/MyPages/AddStreams').default);
Vue.component('customer-service-contact-form', require('./components/Front/CustomerService/CustomerServiceContactForm').default);
Vue.component('bank-id-order-auth', require('./components/Front/Order/BankIdOrderAuth').default);
Vue.component('chat-button', require('./components/Front/ChatButton').default);
Vue.component('friendly-captcha', require('./components/Front/FriendlyCaptcha.vue').default);

// Directive for fetching a count from a URL and setting it as the innerHTML of an element
Vue.directive('fetch-count', {
    bind: function (el, binding) {
        const url = binding.value;
        if (typeof url !== 'string') {
            return;
        }

        window.axios.get(url).then(response => {
            const count = response.data.count;
            if (count === 0) {
                el.classList.add('hidden');
            } else {
                el.classList.remove('hidden');
                el.innerHTML = response.data.count;
            }
        });
    },
});

new Vue({
    el: '#app',
    mounted() {
        FormLoader.autoBindToForms();
    },
});
